function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Sentry from "@sentry/core";
import { cloneElement, forwardRef, memo, useCallback, useEffect, useImperativeHandle, useRef, useState } from "react";
import { Platform, TouchableWithoutFeedback } from "react-native";
import { AutoScrollFlatList } from "react-native-autoscroll-flatlist";
import { Actor, ChatSide, Kind } from "@oui/lib/src/types";
import { useAccessibilityContext } from "./AccessibilityContext";
import { useAppContext } from "./AppContext";
import { ChatArtifactPreview } from "./ChatArtifactPreview";
import { ChatAsset, getAccessibilityTextForChatAsset } from "./ChatAsset";
import { ChatHeader } from "./ChatHeader";
import { ChatTable } from "./ChatTable";
import { AnimatingChatText, ChatText } from "./ChatText";
import { ChatTypingIndicator } from "./ChatTypingIndicator";
import { useConversationContext } from "./ConversationContext";
import { Icon } from "./Icon";
import { Text } from "./Text";
import { View } from "./View";
import { Shadow, useTheme } from "../styles";
var contentContainerStyle = {
    flexGrow: 1,
    justifyContent: 'flex-end'
};
var keyExtractor = function(param) {
    var ID = param.envelope.ID;
    return "chat-".concat(ID);
};
function getAccessibilityTextForChatEnvelope(envelope) {
    switch(envelope.kind){
        case Kind.ChatText:
            // TODO handle markdown here...
            return envelope.props.text.join('').replace(/\*/g, '');
        case Kind.ChatArtifactPreview:
            return "Artifact preview: ".concat(envelope.props.linkText);
        case Kind.ChatAsset:
            return getAccessibilityTextForChatAsset(envelope.props);
        case Kind.ChatTable:
            return "Table with columns: ".concat(envelope.props.data[0].join(', '));
    }
}
var ChatItem = /*#__PURE__*/ memo(function(param) {
    var curr = param.item, sameSideAsPrevious = param.sameSideAsPrevious, isFirstEnvelope = param.isFirstEnvelope;
    var flags = useAppContext().flags;
    var theme = useTheme().theme;
    var el = null;
    switch(curr.kind){
        case Kind.ChatText:
            var _curr_props = curr.props, text = _curr_props.text, rest = _object_without_properties(_curr_props, [
                "text"
            ]);
            el = /*#__PURE__*/ _jsx(ChatText, _object_spread_props(_object_spread({}, rest), {
                value: text[0],
                side: curr.from === Actor.User ? ChatSide.END : ChatSide.START,
                sameSideAsPrevious: sameSideAsPrevious
            }));
            break;
        case Kind.ChatArtifactPreview:
            el = /*#__PURE__*/ _jsx(ChatText, {
                accessible: false,
                bubbleStyle: {
                    borderColor: theme.color.primary100
                },
                value: /*#__PURE__*/ _jsx(ChatArtifactPreview, _object_spread({}, curr.props)),
                side: curr.from === Actor.User ? ChatSide.END : ChatSide.START,
                sameSideAsPrevious: sameSideAsPrevious
            });
            break;
        case Kind.ChatTable:
            el = /*#__PURE__*/ _jsx(ChatText, {
                accessible: false,
                bubbleStyle: {
                    maxWidth: '100%',
                    padding: 0
                },
                value: /*#__PURE__*/ _jsx(ChatTable, _object_spread({}, curr.props)),
                side: curr.from === Actor.User ? ChatSide.END : ChatSide.START,
                sameSideAsPrevious: sameSideAsPrevious
            });
            break;
        case Kind.ChatAsset:
            el = /*#__PURE__*/ _jsx(ChatText, {
                accessible: false,
                bubbleStyle: {
                    maxWidth: '100%',
                    padding: 0
                },
                value: /*#__PURE__*/ _jsx(ChatAsset, _object_spread({}, curr.props)),
                side: curr.from === Actor.User ? ChatSide.END : ChatSide.START,
                sameSideAsPrevious: sameSideAsPrevious
            });
            break;
    }
    var inner = /*#__PURE__*/ cloneElement(el, {
        extraMargin: !(sameSideAsPrevious || isFirstEnvelope)
    });
    return flags.showEnvelopeIDInChat ? /*#__PURE__*/ _jsxs(View, {
        children: [
            /*#__PURE__*/ _jsx(Text, {
                text: curr.ID,
                style: {
                    marginBottom: -8,
                    marginLeft: 10
                }
            }),
            inner
        ]
    }) : inner;
});
function ListHeader() {
    var _useConversationContext = useConversationContext(), botName = _useConversationContext.botName, botAvatar = _useConversationContext.botAvatar;
    return /*#__PURE__*/ _jsxs(View, {
        children: [
            /*#__PURE__*/ _jsx(ChatHeader, {}),
            /*#__PURE__*/ _jsx(View, {
                flex: 1
            }),
            /*#__PURE__*/ _jsxs(View, {
                row: true,
                style: {
                    paddingHorizontal: 10
                },
                spacing: 8,
                children: [
                    botAvatar,
                    /*#__PURE__*/ _jsx(Text, {
                        text: botName,
                        weight: "semibold",
                        size: 17
                    })
                ]
            })
        ]
    });
}
function getFlatListData(envelopes) {
    return _to_consumable_array(envelopes).reverse().map(function(envelope, i, arr) {
        var _arr_;
        return {
            envelope: envelope,
            sameSideAsPrevious: envelope.from === ((_arr_ = arr[i + 1]) === null || _arr_ === void 0 ? void 0 : _arr_.from),
            isFirstEnvelope: i === arr.length - 1
        };
    });
}
/**
 * Displays messages for a chat conversation. Handles animation of incoming
 * messages. Allows scrolling and when scrolls up displays a "jump to bottom"
 * button.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-68}
 */ export var Chat = /*#__PURE__*/ forwardRef(function(props, ref) {
    var _history_;
    var _useState = _sliced_to_array(useState(function() {
        return getFlatListData(props.messages);
    }), 2), history = _useState[0], setHistory = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), newEnvelope = _useState1[0], setNewEnvelope = _useState1[1];
    var alreadyWarned = useRef(false);
    var timeoutRef = useRef(0);
    var callbackRef = useRef(undefined);
    var listRef = useRef(null);
    var announceForAccessibility = useAccessibilityContext().announceForAccessibility;
    var _useState2 = _sliced_to_array(useState('list'), 2), listKeyHack = _useState2[0], setListKeyHack = _useState2[1];
    var layoutBugTimeoutHackRef = useRef(undefined);
    var accentColor = useConversationContext().accentColor;
    useImperativeHandle(ref, function() {
        return {
            scrollToEnd: function() {
                var _listRef_current;
                return (_listRef_current = listRef.current) === null || _listRef_current === void 0 ? void 0 : _listRef_current.scrollToEnd();
            }
        };
    });
    useEffect(function() {
        var callback = function callback() {
            setHistory(function(h) {
                return [
                    {
                        envelope: newMsg,
                        sameSideAsPrevious: sameSideAsPrevious,
                        isFirstEnvelope: h.length === 0
                    }
                ].concat(_to_consumable_array(h));
            });
            var chatAccessibilityText = getAccessibilityTextForChatEnvelope(newMsg);
            announceForAccessibility(sameSideAsPrevious ? chatAccessibilityText : newMsg.from === Actor.Bot ? "Aviva sent: ".concat(chatAccessibilityText) : "You sent: ".concat(chatAccessibilityText));
            setNewEnvelope(null);
        };
        var _history_;
        var lastMessage = props.messages[props.messages.length - 1];
        var lastHistory = history[0];
        // history may be send multiple times if we first load cached history then new history from
        // the server, so check if new messages are history and not yet added to local history state
        if ((lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.history) && (!lastHistory || lastHistory.envelope.ID !== lastMessage.ID)) {
            setHistory(getFlatListData(props.messages));
            return;
        }
        if (history.length === props.messages.length) return;
        var lengthDiff = props.messages.length - history.length;
        if (Math.abs(lengthDiff) > 1 && alreadyWarned.current === false) {
            alreadyWarned.current = true;
            Sentry.withScope(function(scope) {
                var _history_, _props_messages_, _props_messages_1, _props_messages_2;
                scope.setExtras({
                    lengthDiff: lengthDiff,
                    lastHistoryID: (_history_ = history[0]) === null || _history_ === void 0 ? void 0 : _history_.envelope.ID,
                    lastMessageID: (_props_messages_ = props.messages[props.messages.length - 1]) === null || _props_messages_ === void 0 ? void 0 : _props_messages_.ID,
                    secondToLastMessageID: (_props_messages_1 = props.messages[props.messages.length - 2]) === null || _props_messages_1 === void 0 ? void 0 : _props_messages_1.ID,
                    thirdToLastMessageID: (_props_messages_2 = props.messages[props.messages.length - 3]) === null || _props_messages_2 === void 0 ? void 0 : _props_messages_2.ID
                });
                Sentry.captureMessage('Chat has multiple new messages but only 1 is expected');
            });
        }
        var newMsg = props.messages[props.messages.length - lengthDiff];
        if (!newMsg) return;
        var sameSideAsPrevious = ((_history_ = history[0]) === null || _history_ === void 0 ? void 0 : _history_.envelope.from) === newMsg.from;
        if (Platform.OS === 'web' && global.e2e) {
            callback();
            return;
        }
        setNewEnvelope(newMsg);
        clearTimeout(timeoutRef.current);
        if (callbackRef.current) {
            callbackRef.current();
        }
        timeoutRef.current = setTimeout(callback, newMsg.from === Actor.User ? 1300 : 1300);
        return function() {
            clearTimeout(timeoutRef.current);
            callbackRef.current = undefined;
        };
    }, [
        history,
        props.messages,
        announceForAccessibility
    ]);
    var sameSideAsPrevForNewEnvelope = ((_history_ = history[0]) === null || _history_ === void 0 ? void 0 : _history_.envelope.from) === (newEnvelope === null || newEnvelope === void 0 ? void 0 : newEnvelope.from);
    var renderItem = useCallback(function(param) {
        var item = param.item, i = param.index;
        return /*#__PURE__*/ _jsx(ChatItem, {
            item: item.envelope,
            sameSideAsPrevious: item.sameSideAsPrevious,
            isFirstEnvelope: item.isFirstEnvelope
        });
    }, []);
    return /*#__PURE__*/ _jsx(AutoScrollFlatList, {
        ref: listRef,
        threshold: 200,
        showNewItemAlert: false,
        windowSize: 101,
        initialNumToRender: 100,
        maxToRenderPerBatch: 100,
        contentContainerStyle: contentContainerStyle,
        data: _to_consumable_array(history).reverse(),
        keyExtractor: keyExtractor,
        ListEmptyComponent: function() {
            return props.hasEnvelopes ? null : /*#__PURE__*/ _jsx(View, {
                children: /*#__PURE__*/ _jsx(ChatText, {
                    value: /*#__PURE__*/ _jsx(ChatTypingIndicator, {}),
                    side: ChatSide.START
                })
            });
        },
        ListHeaderComponent: ListHeader,
        ListFooterComponent: function() {
            return newEnvelope ? /*#__PURE__*/ _jsx(AnimatingChatText, {
                sameSideAsPrevious: sameSideAsPrevForNewEnvelope,
                actor: newEnvelope.from,
                children: /*#__PURE__*/ _jsx(ChatItem, {
                    item: newEnvelope,
                    sameSideAsPrevious: sameSideAsPrevForNewEnvelope,
                    isFirstEnvelope: history.length === 0
                })
            }) : null;
        },
        renderItem: renderItem,
        onScroll: function() {
            return clearTimeout(layoutBugTimeoutHackRef.current);
        },
        indicatorComponent: /*#__PURE__*/ _jsx(TouchableWithoutFeedback, {
            role: "button",
            "aria-label": "Scroll to end",
            onPress: function() {
                var _listRef_current;
                layoutBugTimeoutHackRef.current = setTimeout(function() {
                    setListKeyHack(Math.random.toString());
                }, 200);
                (_listRef_current = listRef.current) === null || _listRef_current === void 0 ? void 0 : _listRef_current.scrollToEnd();
            },
            children: /*#__PURE__*/ _jsx(View, {
                style: [
                    {
                        width: 36,
                        height: 36,
                        borderRadius: 20,
                        backgroundColor: 'white',
                        position: 'absolute',
                        bottom: 12,
                        right: 12,
                        alignItems: 'center',
                        justifyContent: 'center'
                    },
                    Shadow.low
                ],
                children: /*#__PURE__*/ _jsx(Icon, {
                    name: "double-chevron-down",
                    color: accentColor,
                    size: 18
                })
            })
        })
    }, listKeyHack);
});
